export default __webpack_public_path__ + "static/media/cor2.6b6b7e01.jpeg";